import { profileKey } from '@staffedupusa/shared-components';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage, updateSocialImageLogoRoute } from '@features/profile';
import axiosInstance from '@server/axiosInstance';

type useUpdateSocialImageProps = {
  setAlertText?: Dispatch<SetStateAction<string>>;
};

export const useUpdateSocialImage = ({
  setAlertText = () => { },
}: useUpdateSocialImageProps) => {
  const client = useQueryClient();
  const metricsKey = 'metrics';
  const { mutate: updateSocialImage, isLoading: isUpdatingSocialImage } =
    useMutation({
      mutationFn: (variables: { cover_image?: string, company_id: string | number }) =>
        axiosInstance.post(updateSocialImageLogoRoute, variables).then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setAlertText(data.message);
        } else {
          setAlertText('');
          client.invalidateQueries([metricsKey]);
        }
      },
      onError: () => {
        setAlertText(errorMessage);
      },
    });

  return {
    updateSocialImage,
    isUpdatingSocialImage,
  };
};
